import { render, staticRenderFns } from "./PresentationRefont.vue?vue&type=template&id=39d0c20c&scoped=true"
import script from "./PresentationRefont.vue?vue&type=script&lang=js"
export * from "./PresentationRefont.vue?vue&type=script&lang=js"
import style0 from "./PresentationRefont.vue?vue&type=style&index=0&id=39d0c20c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d0c20c",
  null
  
)

export default component.exports